import React, { createContext, useContext, useEffect, useState } from "react";

const PWAInstallContext = createContext(null);

export function PWAInstallProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const isIOS =
    /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

  const isInstalled =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const triggerInstall = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setDeferredPrompt(null);
    return outcome === "accepted";
  };

  // Show the button if not already installed and either the native prompt
  // is available (Chrome/Edge/Android) or we're on iOS (manual instructions).
  const canInstall = !isInstalled && (deferredPrompt !== null || isIOS);

  return (
    <PWAInstallContext.Provider value={{ canInstall, isIOS, triggerInstall }}>
      {children}
    </PWAInstallContext.Provider>
  );
}

export const usePWAInstall = () => useContext(PWAInstallContext);
